import { Component, OnInit, Input } from '@angular/core';

import { FormGroup } from '@angular/forms';
import { FieldModel } from './field-model';

@Component({
  selector: 'pg-component-factory, grit-component-factory',
  templateUrl: './pg-component-factory.component.html',
  styleUrls: ['./pg-component-factory.component.scss'],
})
export class PgComponentFactoryComponent implements OnInit {
  @Input()
  model: FieldModel;

  @Input()
  parentFormGroup: FormGroup;

  constructor() {}

  ngOnInit() {}
}
